export const newsData = [
  {
    id: 1,
     date: '2025.11.26',
    category: 'お知らせ',
    title: 'ウェブサイトをリニューアルいたしました',
    content: `
      ウェブサイトのリニューアルを完了しました。今後ともよろしくお願いいたします。
    `
  },
  {
    id: 2,
    date: '2025.11.26',
    category: '広告',
    title: '兵庫県三田市「三田陶芸の森。」特別日帰りツアーのご案内',
    content: `
      兵庫県三田市にある「三田陶芸の森。」が特別日帰りツアーを企画。
      世界三大青磁の一つと称される「三田青磁」。
      通常非公開の製造工程の見学や加飾、窯入れ体験。
      三田の食材とお茶をテーマにした特別料理。本格茶道体験。
    　詳しくは下記「三田陶芸の森。」特別ページをご覧ください。
    `,
    image: 'https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/93bf2747-bd30-4587-95da-a6d02e66bead.jpg',
    links: [
      {
        text: '三田陶芸の森 特別日帰りツアーページ',
        url: 'https://origamiconcierge.jp/ja/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50'
      }
    ]
  },
  {
    id: 3,
    date: '2025.12.01',
    category: 'お知らせ',
    title: '合併に関するご案内',
    content: `
      このたび株式会社J・T・Cは、令和7年12月1日をもちまして株式会社カオスゲートと合併しました。株式会社カオスゲートを存続会社として新たに発足いたしました。
なお、存続会社である株式会社カオスゲートは、同日付で「株式会社J・T・C」へ商号を変更いたしました。
これにより、従来の株式会社J・T・Cの業務は新「株式会社J・T・C」が継承し、これまで同様、皆様のご期待に沿えるよう一層の努力を重ねてまいります。
また、旧株式会社J・T・Cの本社は、新会社の営業所として存続いたしますので、所在地および電話番号の変更はございません。決済業務等につきましても従前どおりお取り扱いいただけます。
今後とも倍旧のご支援とご厚誼を賜りますようお願い申し上げます。

    `,
  },
  
];